import { render, staticRenderFns } from "./PopupForm.vue?vue&type=template&id=07cb2ad7&"
import script from "./PopupForm.vue?vue&type=script&lang=js&"
export * from "./PopupForm.vue?vue&type=script&lang=js&"
import style0 from "./PopupForm.vue?vue&type=style&index=0&id=07cb2ad7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports